var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g2, _path42, _path43, _path44, _path45, _g3, _path46, _path47, _path48, _g4, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g5, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _g6, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _g7, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _g8, _path144, _path145, _path146, _g9, _path147, _path148, _path149, _g0, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 400,
    viewBox: "0 0 500 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M67.9308 133.669C67.9308 133.669 40.0538 191.259 79.2278 249.271C118.402 307.284 199.107 337.913 263.697 364.11C328.287 390.307 395.358 377.549 427.231 334.639C459.104 291.73 415.386 261.097 415.334 199.905C415.283 138.713 426.781 122.511 385.371 70.8137C343.961 19.1153 242.312 7.67375 165.471 46.0169C88.6308 84.3601 67.9308 133.669 67.9308 133.669Z",
    fill: "#FDF9F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7034 66.2929C113.152 53.4305 131.338 43.4753 153.015 43.6889C190.005 44.0529 210 70.2505 231.238 90.4633C242.25 100.945 254.725 111.057 271.066 115.979C295.583 123.365 322.88 119.052 346.763 112.197C357.461 109.127 370.135 104.808 382.183 107.013C418.814 113.717 414.997 149.482 408.946 172.124C400.776 202.696 387.5 235.247 360.587 258.739C296.162 314.972 180.208 280.5 122.093 235.628C117.821 232.33 113.728 228.883 109.88 225.266C99.9274 215.908 91.3844 205.586 84.7194 194.51C65.9724 163.354 63.3944 125.476 79.6374 93.2769C84.3574 83.9185 91.1914 74.4337 99.7034 66.2929Z",
    fill: "#586AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M99.7034 66.2929C113.152 53.4305 131.338 43.4753 153.015 43.6889C190.005 44.0529 210 70.2505 231.238 90.4633C242.25 100.945 254.725 111.057 271.066 115.979C295.583 123.365 322.88 119.052 346.763 112.197C357.461 109.127 370.135 104.808 382.183 107.013C418.814 113.717 414.997 149.482 408.946 172.124C400.776 202.696 387.5 235.247 360.587 258.739C296.162 314.972 180.208 280.5 122.093 235.628C117.821 232.33 113.728 228.883 109.88 225.266C99.9274 215.908 91.3844 205.586 84.7194 194.51C65.9724 163.354 63.3944 125.476 79.6374 93.2769C84.3574 83.9185 91.1914 74.4337 99.7034 66.2929Z",
    fill: "#FDF9F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300.342 259.773H325.289V251.756H300.342V259.773Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287.869 249.189H312.816V241.172H287.869V249.189Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.614 184.471H255.561V176.453H230.614V184.471Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.282 174.496H269.229V166.478H244.282V174.496Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.141 84.1855H362.088V76.1679H337.141V84.1855Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M323.959 73.5137H348.906V65.4961H323.959V73.5137Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M143.43 77.833H168.377V69.8154H143.43V77.833Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M130.246 67.1602H155.193V59.1426H130.246V67.1602Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.494 112.403H243.441V104.386H218.494V112.403Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M351.629 160.966H376.576V152.948H351.629V160.966Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M381.274 231.21H406.221V223.192H381.274V231.21Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M258.569 184.471H283.516V176.453H258.569V184.471Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M357.162 207.767C332.907 207.554 307.907 207.554 284.402 207.767",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M367.152 207.767C365.12 207.767 363.087 207.767 361.055 207.767",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0391 230.328C100.294 230.541 125.294 230.541 148.799 230.328",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0488 230.328C68.0808 230.328 70.1138 230.328 72.1458 230.328",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M242.324 125.016C243.471 125.016 244.618 125.016 245.765 125.016",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M206.072 125.016C216.854 125.016 227.635 125.016 238.417 125.016",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4118 176.793H63.4648V184.811H88.4118V176.793Z",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5826 164.182C63.4356 164.182 62.2886 164.182 61.1426 164.182",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M100.835 164.182C90.0532 164.182 79.2722 164.182 68.4902 164.182",
    stroke: "#586AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.791 324.823H465.209",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M299.28 332.948C299.28 332.948 292.837 340.244 299.505 342.686C306.173 345.128 365.239 339.509 392.876 339.276C420.513 339.044 435.621 330.721 435.034 328.188C434.448 325.656 427.696 320.848 427.696 320.848L423.007 325.244C423.007 325.244 428.043 326.44 427.868 328.295C427.693 330.15 409.417 336.19 386.385 333.646C363.353 331.102 314.28 338.992 310.411 338.64C306.542 338.288 310.242 331.328 310.242 331.328L299.28 332.948Z",
    fill: "#193A5F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M392.004 335.857C355.694 337.873 295.364 337.193 295.364 337.193C264.224 335.377 258.324 327.161 263.224 317.809C270.794 303.401 304.044 286.329 310.104 285.929C320.094 285.281 330.624 288.457 330.624 288.457L337.124 287.361C335.124 283.049 355.674 273.449 365.064 277.593C374.444 281.745 393.864 276.049 399.714 278.969C401.334 279.777 402.624 280.873 403.634 282.033C406.284 285.065 407.064 288.561 407.064 288.561C407.064 288.561 407.074 288.561 407.094 288.553C407.114 288.553 407.144 288.545 407.174 288.537C407.184 288.545 407.184 288.537 407.194 288.537C407.664 288.425 409.404 288.073 411.694 287.977C414.914 287.841 419.204 288.233 422.564 290.577C423.334 291.113 424.154 291.769 425.014 292.513C431.074 297.809 438.874 307.817 440.674 313.657C442.724 320.321 428.304 333.833 392.004 335.857Z",
    fill: "#999999"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_146_427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 261,
    y: 276,
    width: 180,
    height: 62
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M392.004 335.857C355.694 337.873 295.364 337.193 295.364 337.193C264.224 335.377 258.324 327.161 263.224 317.809C270.794 303.401 304.044 286.329 310.104 285.929C320.094 285.281 330.624 288.457 330.624 288.457L337.124 287.361C335.124 283.049 355.674 273.449 365.064 277.593C374.444 281.745 393.864 276.049 399.714 278.969C401.334 279.777 402.624 280.873 403.634 282.033C406.284 285.065 407.064 288.561 407.064 288.561C407.064 288.561 407.074 288.561 407.094 288.553C407.114 288.553 407.144 288.545 407.174 288.537C407.184 288.545 407.184 288.537 407.194 288.537C407.664 288.425 409.404 288.073 411.694 287.977C414.914 287.841 419.204 288.233 422.564 290.577C423.334 291.113 424.154 291.769 425.014 292.513C431.074 297.809 438.874 307.817 440.674 313.657C442.724 320.321 428.304 333.833 392.004 335.857Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_146_427)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M360.873 282.13C359.103 279.642 381.453 280.818 383.823 282.13C386.203 283.442 386.203 287.554 388.773 286.442C390.823 285.562 398.633 282.178 403.633 282.034C406.283 285.066 407.063 288.562 407.063 288.562C407.063 288.562 376.313 295.514 374.333 293.666C372.353 291.826 379.873 290.282 382.243 286.226C384.613 282.17 375.123 283.282 373.153 283.314C371.173 283.338 362.643 284.61 360.873 282.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M392.004 335.858C355.694 337.874 295.364 337.194 295.364 337.194C264.224 335.378 258.324 327.162 263.224 317.81C264.424 318.562 266.484 318.897 269.864 318.377C280.974 316.665 287.294 316.194 294.424 321.57C301.544 326.954 309.664 330.226 313.404 329.17C313.404 329.17 313.924 317.282 328.404 308.746C342.884 300.21 346.294 302.634 349.184 300.37C352.084 298.106 353.784 294.002 345.484 291.634C337.194 289.274 333.144 288.458 333.144 288.458C333.144 288.458 342.284 287.889 350.204 290.729C358.114 293.561 365.034 300.338 361.674 301.858C358.314 303.378 366.614 306.105 372.354 305.377C377.434 304.721 394.294 304.65 397.674 304.538C394.644 305.05 381.254 308.401 381.254 310.977C381.254 310.977 385.394 316.418 385.364 322.57C385.334 328.714 394.334 329.506 398.274 327.202C402.224 324.898 403.004 321.738 401.524 315.722C400.044 309.706 395.904 309.258 390.554 310.194C390.554 310.194 397.474 306.858 399.654 307.962C401.824 309.074 407.954 308.602 409.144 313.818C410.334 319.042 406.174 323.314 408.154 324.738C410.134 326.162 421.604 324.578 423.584 321.57C425.564 318.57 424.254 301.114 422.344 300.746C420.464 300.386 410.884 302.722 410.614 302.786C410.694 302.586 412.054 299.426 416.464 298.802C419.984 298.306 424.324 295.538 425.014 292.514C431.074 297.81 438.874 307.818 440.674 313.658C442.724 320.322 428.304 333.834 392.004 335.858Z",
    fill: "black"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M392.004 335.857C355.694 337.873 295.364 337.193 295.364 337.193C264.224 335.377 258.324 327.161 263.224 317.809C270.794 303.401 304.044 286.329 310.104 285.929C320.094 285.281 330.624 288.457 330.624 288.457L337.124 287.361C335.124 283.049 355.674 273.449 365.064 277.593C374.444 281.745 393.864 276.049 399.714 278.969C401.334 279.777 402.624 280.873 403.634 282.033C406.284 285.065 407.064 288.561 407.064 288.561C407.064 288.561 407.074 288.561 407.094 288.553C407.114 288.553 407.144 288.545 407.174 288.537C407.184 288.545 407.184 288.537 407.194 288.537C407.664 288.425 409.404 288.073 411.694 287.977C414.914 287.841 419.204 288.233 422.564 290.577C423.334 291.113 424.154 291.769 425.014 292.513C431.074 297.809 438.874 307.817 440.674 313.657C442.724 320.321 428.304 333.833 392.004 335.857Z",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M330.622 288.457C330.622 288.457 335.167 289.67 346.64 291.855C358.113 294.039 351.783 301.441 343.475 301.855C335.167 302.268 313.808 317.109 313.409 327.202C313.01 337.295 329.999 335.815 329.999 335.815",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M337.127 287.361C337.127 287.361 352.968 286.821 363.65 291.855C374.331 296.889 402.815 289.846 402.815 289.846",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M382.244 310.974C386.991 316.193 385.013 332.881 385.013 332.881C385.013 332.881 416.383 330.589 425.028 324.974C433.673 319.358 426.156 301.087 421.409 300.412C416.662 299.737 399.255 307.661 385.409 309.237",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M387.387 310.975C387.387 310.975 397.277 307.971 399.255 310.975C401.233 313.979 405.157 324.162 402.815 327.688C400.473 331.215 391.738 330.56 391.738 330.56",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M350.199 279.165C350.199 279.165 362.841 283.43 369.971 283.355C377.1 283.279 385.408 282.847 382.243 286.227C379.078 289.609 378.287 290.726 378.287 290.726",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M318.975 316.838C318.975 316.838 333.189 320.805 348.618 318.974C364.047 317.143 366.569 319.332 366.569 319.332V327.687C366.569 327.687 356.53 326.207 350.201 327.687C343.871 329.168 322.904 330.298 313.41 327.201",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M314.807 322.565C314.807 322.565 320.037 323.737 333.141 323.763C346.245 323.789 358.509 322.898 358.509 322.898",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M311.72 298.039L311.315 294.401C311.269 293.982 311.618 293.601 312.132 293.511L322.748 291.654C323.358 291.548 323.947 291.89 324.01 292.387L324.44 295.823C324.492 296.237 324.153 296.62 323.647 296.717L313.006 298.777C312.385 298.897 311.777 298.547 311.72 298.039Z",
    fill: "#586AFF",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M315.584 294.042L321.32 294.832L320.034 295.436L313.902 294.74L315.584 294.042Z",
    fill: "#193A5F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M327.354 289.609C327.354 289.609 330.519 287.343 334.376 287.344C338.233 287.345 341.2 288.293 340.805 288.477C340.409 288.66 334.278 289.629 333.141 290.726L327.354 289.609Z",
    fill: "#193A5F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M270.288 328.21C270.288 328.21 257.827 331.464 264.552 335.262C271.277 339.06 280.376 338.268 287.794 334.471L288.585 330.91C288.585 330.91 284.036 331.405 280.178 332.977C276.321 334.549 267.321 332.967 267.914 332.096C268.507 331.226 270.09 331.226 270.09 331.226L270.288 328.21Z",
    fill: "#193A5F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M308.677 336.954C309.603 340.928 344.364 335.194 372.587 331.208C400.811 327.223 425.793 331.843 427.868 328.295C429.943 324.746 435.034 328.189 435.034 328.189C435.034 328.189 431.648 334.262 423.367 336.971C415.085 339.679 376.198 339.047 354.387 342.625C332.576 346.203 293.832 351.411 296.619 337.834L308.677 336.954Z",
    fill: "#193A5F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M74.973 291.186C74.973 291.186 74.404 311.801 117.066 327.002C159.728 342.203 275.729 349.616 296.859 296.044L231.151 280.948H143.009L123.603 287.983L74.973 291.186Z",
    fill: "#586AFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_146_427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 280,
    width: 223,
    height: 59
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M74.973 291.186C74.973 291.186 74.404 311.801 117.066 327.002C159.728 342.203 275.729 349.616 296.859 296.044L231.151 280.948H143.009L123.603 287.983L74.973 291.186Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_146_427)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.973 291.186C74.973 291.186 74.404 311.801 117.066 327.002C159.728 342.203 275.729 349.616 296.859 296.044L231.151 280.948H143.009L123.603 287.983L74.973 291.186Z",
    fill: "black"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M74.973 291.186C74.973 291.186 74.404 311.801 117.066 327.002C159.728 342.203 275.729 349.616 296.859 296.044L231.151 280.948H143.009L123.603 287.983L74.973 291.186Z",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M125.09 200.679C117.351 206.207 90.5098 268.712 93.9798 275.493C97.4498 282.275 142.946 288.539 142.946 288.539C142.946 288.539 138.45 218 138.219 216.821C137.989 215.642 125.09 200.679 125.09 200.679Z",
    fill: "#193A5F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M245.678 200.679C253.417 206.207 280.258 268.712 276.788 275.493C273.318 282.275 227.822 288.539 227.822 288.539C227.822 288.539 232.318 218 232.549 216.821C232.779 215.642 245.678 200.679 245.678 200.679Z",
    fill: "#193A5F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M125.09 200.679C125.09 200.679 142.946 184.537 185.19 183.579C219.13 182.809 242.361 196.256 245.678 200.679C248.995 205.102 230.583 264.069 230.583 264.069L240.887 295.813C240.887 295.813 185.606 310.555 136.221 295.813L142.855 262.3C142.855 262.3 125.458 208.935 125.09 200.679Z",
    fill: "#193A5F"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.752 190.065C208.752 190.065 193.453 203.554 177.92 199.795",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.957 214.961C199.525 215.513 203.158 215.891 206.792 216.081",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.072 197.983C161.777 205.045 176.097 211.098 191.223 214.123",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.303 211.962C233.182 216.795 231.002 222.105 230.66 227.564",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.374 203.333C241.73 204.891 240.264 206.572 238.914 208.299",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.756 220.139C237.846 222.571 231.488 231.195 231.488 231.195C231.488 231.195 235.911 237.828 238.122 245.347",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.254 266.133C234.254 266.133 240.721 265.295 244.757 261.838C248.794 258.382 260.512 259.313 262.171 261.838",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9 257.701C248.9 257.701 253.047 252.643 262.169 256.181",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.686 204.887C128.686 204.887 137.795 209.744 138.682 222.997",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.886 236.312C132.416 241.774 129.735 247.361 128.389 253.086",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.637 222.998C133.054 223.49 138.521 225.324 138.987 227.574C139.204 228.624 137.278 231.136 136.827 232.099",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.697 258.371C122.596 258.121 124.671 258.367 125.983 259.582",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.699 261.838C112.344 260.965 114.082 260.201 115.887 259.561",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.82 264.363C119.82 264.363 120.411 260.419 128.684 261.839C136.957 263.259 156.576 268.126 156.576 268.126",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M206.901 188.839C206.901 188.839 197.401 196.319 185.951 196.319C174.501 196.319 163.471 187.655 163.471 187.655C163.471 187.655 169.401 185.295 170.991 180.567C171.091 180.287 171.171 179.991 171.231 179.695C171.661 177.623 170.971 174.127 169.971 170.615C168.401 165.135 166.071 159.647 166.071 159.647H203.221C203.221 159.647 201.461 166.503 200.301 172.823C200.091 173.983 199.891 175.119 199.741 176.199C199.571 177.359 199.431 178.439 199.361 179.399C198.851 186.095 206.901 188.839 206.901 188.839Z",
    fill: "white",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M241.87 295.872V299.304C241.87 299.494 241.842 299.673 241.786 299.852C241.479 300.858 240.333 301.618 238.963 301.618H137.178C135.809 301.618 134.663 300.858 134.355 299.852C134.299 299.673 134.271 299.494 134.271 299.304V295.872H241.87Z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_146_427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 295,
    width: 108,
    height: 7
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M241.87 295.872V299.304C241.87 299.494 241.842 299.673 241.786 299.852C241.479 300.858 240.333 301.618 238.963 301.618H137.178C135.809 301.618 134.663 300.858 134.355 299.852C134.299 299.673 134.271 299.494 134.271 299.304V295.872H241.87Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_146_427)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M241.87 295.872V299.304C241.87 299.494 241.842 299.673 241.786 299.852H134.355C134.299 299.673 134.271 299.494 134.271 299.304V295.872H241.87Z",
    fill: "black"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M241.87 295.872V299.304C241.87 299.494 241.842 299.673 241.786 299.852C241.479 300.858 240.333 301.618 238.963 301.618H137.178C135.809 301.618 134.663 300.858 134.355 299.852C134.299 299.673 134.271 299.494 134.271 299.304V295.872H241.87Z",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M240.863 298.159H135.275C134.206 298.159 133.249 297.568 133.136 296.838L123.965 237.669C123.81 236.67 124.703 235.856 125.96 235.856H250.178C251.435 235.856 252.328 236.67 252.173 237.669L243.002 296.838C242.889 297.568 241.931 298.159 240.863 298.159Z",
    fill: "#757575",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.696 296.914L126.657 240.169C126.551 239.505 127.249 238.878 128.091 238.878H248.044C248.886 238.878 249.584 239.505 249.478 240.169L240.439 296.914",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M135.696 296.914L126.657 240.169C126.551 239.505 127.249 238.878 128.091 238.878H248.044C248.886 238.878 249.584 239.505 249.478 240.169L240.439 296.914",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M189.269 272.152H178.418L191.021 261.595L185.168 269.972L189.269 272.152Z",
    fill: "#586AFF",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 277.691L198.396 267.356H187.802L191.601 269.6L185.018 277.691Z",
    fill: "#586AFF",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M275.864 331.851L279.059 334.759C279.059 334.759 282.04 340.216 273.771 346.896C265.502 353.576 243.993 354.924 235.629 353.735L230.358 354.303L212.431 351.224C212.431 351.224 203.353 347.67 207.059 341.437C210.766 335.206 275.864 331.851 275.864 331.851Z",
    fill: "#586AFF",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M270.362 345.866C263.431 351.645 241.226 352.797 231.962 351.109C229.433 350.651 220.224 350.383 213.363 348.415C209.66 347.364 206.641 345.821 205.719 343.485C203.064 336.822 226.498 324.145 226.498 324.145C226.498 324.145 241.45 326.448 244.552 327.04C248.814 327.833 252.377 328.146 255.508 328.258C262.621 328.504 267.428 327.744 272.64 329.533C278.579 331.579 278.663 338.935 270.362 345.866Z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_146_427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 324,
    width: 72,
    height: 28
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M270.362 345.866C263.431 351.645 241.226 352.797 231.962 351.109C229.433 350.651 220.224 350.383 213.363 348.415C209.66 347.364 206.641 345.821 205.719 343.485C203.064 336.822 226.498 324.145 226.498 324.145C226.498 324.145 241.45 326.448 244.552 327.04C248.814 327.833 252.377 328.146 255.508 328.258C262.621 328.504 267.428 327.744 272.64 329.533C278.579 331.579 278.663 338.935 270.362 345.866Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_146_427)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M255.508 328.259C250.17 335.235 236.839 348.628 213.363 348.415C209.66 347.364 206.641 345.821 205.719 343.485C203.064 336.822 226.498 324.145 226.498 324.145C226.498 324.145 241.45 326.448 244.552 327.04C248.814 327.834 252.378 328.147 255.508 328.259Z",
    fill: "black"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M270.362 345.866C263.431 351.645 241.226 352.797 231.962 351.109C229.433 350.651 220.224 350.383 213.363 348.415C209.66 347.364 206.641 345.821 205.719 343.485C203.064 336.822 226.498 324.145 226.498 324.145C226.498 324.145 241.45 326.448 244.552 327.04C248.814 327.833 252.377 328.146 255.508 328.258C262.621 328.504 267.428 327.744 272.64 329.533C278.579 331.579 278.663 338.935 270.362 345.866Z",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M222.25 332.279C222.25 332.279 245.258 337.832 249.572 337.474C253.886 337.117 254.42 339.943 254.42 339.943",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M225.938 325.581C225.938 325.581 251.18 329.905 254.232 330.622C257.284 331.339 259.822 330.423 259.822 330.423",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M230.616 325.921C230.616 325.921 230.449 331.969 222.639 335.163",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M235.343 326.61C235.343 326.61 234.986 332.57 228.656 336.374",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M240.368 327.99C240.368 327.99 241.73 333.896 233.881 338.241",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M245.67 328.462C245.67 328.462 246.859 335.905 239.283 339.72",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M251.338 329.111C251.338 329.111 251.142 336.88 244.746 340.207",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M255.788 330.105C255.788 330.105 257.466 336.702 250.602 340.729",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M228.274 321.082C226.038 333.167 202.744 346.302 202.744 346.302C202.744 346.302 196.288 341.461 194.164 341.663C192.026 341.864 183.153 341.361 183.153 341.361C183.153 341.361 112.962 320.356 104.578 320.244C99.3236 320.177 84.1616 316.488 76.6576 306.918C72.1996 301.239 70.4536 293.481 75.0646 283.185C82.6666 266.204 120.131 278.713 156.868 294.945C169.067 300.345 179.897 304.671 188.645 307.969C203.192 313.447 212.037 316.085 212.037 316.085L216.9 314.699L228.274 321.082Z",
    fill: "#586AFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_146_427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 275,
    width: 157,
    height: 72
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M228.274 321.082C226.038 333.167 202.744 346.302 202.744 346.302C202.744 346.302 196.288 341.461 194.164 341.663C192.026 341.864 183.153 341.361 183.153 341.361C183.153 341.361 112.962 320.356 104.578 320.244C99.3236 320.177 84.1616 316.488 76.6576 306.918C72.1996 301.239 70.4536 293.481 75.0646 283.185C82.6666 266.204 120.131 278.713 156.868 294.945C169.067 300.345 179.897 304.671 188.645 307.969C203.192 313.447 212.037 316.085 212.037 316.085L216.9 314.699L228.274 321.082Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_146_427)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M228.274 321.082C226.038 333.167 202.744 346.302 202.744 346.302C202.744 346.302 196.288 341.461 194.164 341.663C192.026 341.864 183.153 341.361 183.153 341.361C183.153 341.361 112.962 320.356 104.578 320.244C99.3242 320.176 84.1622 316.488 76.6582 306.918C85.4752 307.444 100.484 308.617 107.638 310.764C107.638 310.764 99.6312 312.351 101.839 313.894C104.047 315.448 136.159 318.455 147.464 316.175C157.679 314.118 178.081 308.562 188.645 307.969C203.192 313.447 212.037 316.085 212.037 316.085L216.9 314.699L228.274 321.082Z",
    fill: "black"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M228.274 321.082C226.038 333.167 202.744 346.302 202.744 346.302C202.744 346.302 196.288 341.461 194.164 341.663C192.026 341.864 183.153 341.361 183.153 341.361C183.153 341.361 112.962 320.356 104.578 320.244C99.3236 320.177 84.1616 316.488 76.6576 306.918C72.1996 301.239 70.4536 293.481 75.0646 283.185C82.6666 266.204 120.131 278.713 156.868 294.945C169.067 300.345 179.897 304.671 188.645 307.969C203.192 313.447 212.037 316.085 212.037 316.085L216.9 314.699L228.274 321.082Z",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M166.143 309.401C168.631 309.058 171.104 308.646 173.546 308.133",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6953 310.466C120.029 311.767 140.96 312.139 161.209 309.999",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2299 332.97L95.0349 335.879C95.0349 335.879 92.0539 341.335 100.323 348.015C108.592 354.695 130.101 356.043 138.465 354.854L143.736 355.423L161.663 352.343C161.663 352.343 170.741 348.789 167.035 342.556C163.328 336.325 98.2299 332.97 98.2299 332.97Z",
    fill: "#586AFF",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M147.598 325.266C147.598 325.266 132.65 327.567 129.546 328.154C115.65 330.78 108.955 328.078 101.46 330.654C95.5205 332.696 95.4325 340.058 103.731 346.982C110.661 352.765 132.867 353.918 142.134 352.232C146.022 351.525 165.736 351.253 168.381 344.598C171.025 337.943 147.598 325.266 147.598 325.266Z",
    fill: "#757575",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M151.844 333.397C151.844 333.397 128.837 338.95 124.522 338.593C120.208 338.235 119.674 341.061 119.674 341.061",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M148.156 326.699C148.156 326.699 122.913 331.023 119.861 331.74C116.809 332.457 114.271 331.542 114.271 331.542",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M143.479 327.039C143.479 327.039 143.646 333.087 151.456 336.281",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M138.752 327.729C138.752 327.729 139.109 333.689 145.439 337.493",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M133.725 329.108C133.725 329.108 132.363 335.014 140.212 339.359",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M128.423 329.581C128.423 329.581 127.234 337.023 134.81 340.839",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M122.756 330.229C122.756 330.229 122.952 337.998 129.348 341.325",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M118.304 331.224C118.304 331.224 116.626 337.82 123.49 341.847",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M297.569 283.069C289.921 266.096 252.49 278.662 215.799 294.954C183.358 309.361 160.674 316.175 160.674 316.175L155.815 314.798L144.451 321.205C146.709 333.286 170.048 346.381 170.048 346.381C170.048 346.381 176.483 341.529 178.616 341.726C180.75 341.924 189.614 341.408 189.614 341.408C189.614 341.408 259.766 320.293 268.143 320.177C276.522 320.062 310.024 310.71 297.569 283.069Z",
    fill: "#586AFF",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M195.775 326.679C197.804 326.795 199.838 326.856 201.872 326.867",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M160.676 316.176C168.004 322.404 180.042 325.103 190.225 326.221",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M243.244 305.166C257.59 307.355 273.555 309.352 287.991 306.652",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M232.23 303.245C234.256 303.656 236.294 304.024 238.337 304.374",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M200.301 172.824C200.091 173.984 199.891 175.12 199.741 176.2C196.001 179.264 189.791 183.48 183.731 183.624C179.341 183.728 174.711 182.224 170.991 180.568C171.091 180.288 171.171 179.992 171.231 179.696C171.661 177.624 170.971 174.128 169.971 170.616L200.301 172.824Z",
    fill: "#193A5F"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M210.016 153.424C210.016 153.424 212.746 151.371 214.087 152.045C215.428 152.72 217.012 154.633 216.281 156.377C215.55 158.121 212.381 161.16 212.137 162.932C211.893 164.704 210.25 166.712 208.451 165.539C206.652 164.367 210.016 153.424 210.016 153.424Z",
    fill: "white",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M161.381 153.424C161.381 153.424 158.651 151.371 157.31 152.045C155.969 152.72 154.385 154.633 155.116 156.377C155.847 158.121 159.016 161.16 159.26 162.932C159.504 164.704 161.147 166.712 162.946 165.539C164.745 164.366 161.381 153.424 161.381 153.424Z",
    fill: "white",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M185.102 125.358C220.6 125.358 210.996 159.696 204.464 171.838C202.17 176.102 190.849 182.079 185.102 182.079C179.756 182.079 169.067 176.45 166.898 172.443C160.29 160.241 151.266 125.358 185.102 125.358Z",
    fill: "white",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M191.119 153.183C191.119 153.183 200.364 150.897 203.221 155.468",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M197.964 159.402C197.964 160.275 197.41 160.982 196.727 160.982C196.044 160.982 195.49 160.275 195.49 159.402C195.49 158.529 196.044 157.822 196.727 157.822C197.41 157.822 197.964 158.529 197.964 159.402Z",
    fill: "#193A5F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M180.278 153.183C180.278 153.183 171.033 150.897 168.176 155.468",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M173.434 159.402C173.434 160.275 173.988 160.982 174.671 160.982C175.354 160.982 175.908 160.275 175.908 159.402C175.908 158.529 175.354 157.822 174.671 157.822C173.988 157.822 173.434 158.529 173.434 159.402Z",
    fill: "#193A5F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M181.534 165.89C180.189 167.033 184.83 168.915 185.703 168.915C186.576 168.915 190.106 167.436 190.106 166.562",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M181.534 165.89C180.189 167.033 184.83 168.915 185.703 168.915C186.576 168.915 190.106 167.436 190.106 166.562",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M199.837 135.029C199.837 135.029 187.105 138.861 172.482 135.029C172.482 135.029 167.692 134.805 165.801 136.732C163.91 138.659 165.801 144.61 166.305 147.03C166.809 149.45 162.145 151.131 162.775 157.249L162.145 159.56C162.145 159.56 156.977 149.047 158.237 140.575C159.498 132.103 165.17 129.279 165.17 129.279C165.17 129.279 168.217 121.963 186.08 122.018C205.332 122.077 207.275 130.414 207.275 130.414C207.275 130.414 219.251 137.65 209.595 160.341L208.578 157.248C208.578 157.248 209.595 152.676 206.141 148.643C204.459 146.679 207.149 140.776 206.519 137.751C205.888 134.727 199.837 135.029 199.837 135.029Z",
    fill: "#193A5F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M177.99 171.696C177.99 171.696 181.184 173.038 185.698 173.038C190.212 173.038 193.068 172.043 193.068 172.043",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M177.99 171.696C177.99 171.696 181.184 173.038 185.698 173.038C190.212 173.038 193.068 172.043 193.068 172.043",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M199.057 137.732C199.057 137.732 200.197 142.744 203.22 146.577C206.243 150.409 209.762 150.797 210.767 155.468C210.767 155.468 219.984 143.039 212.193 132.13C212.193 132.13 209.746 119.747 185.698 119.747C161.65 119.747 150.532 133.146 159.868 153.719C159.868 153.719 167.33 151.442 168.175 144.661C168.175 144.661 169.205 148.62 165.704 152.611C165.704 152.611 178.082 151.147 181.291 142.892C181.291 142.892 180.043 148.38 175.908 150.705C175.908 150.705 180.581 155.422 185.95 148.051C191.318 140.681 194.45 136.258 199.057 137.732Z",
    fill: "#193A5F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.093 139.342C178.591 141.06 176.482 143.72 173.434 143.463",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M197.964 132.201C193.915 125.609 185.13 133.684 182.26 136.875",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.081 133.661C163.065 134.355 161.931 134.947 160.629 135.223",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.069 126.044C184.903 119.21 173.322 127.162 166.854 131.715",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M209.57 133.828C211.043 135.547 211.785 137.609 212.194 139.647",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M203.221 130.959C204.514 130.916 205.804 131.232 206.904 131.768",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.738 127.517C200.738 127.517 202.509 123.771 206.074 126.514",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M215.714 231.042H158.494C155.844 231.042 153.695 229.323 153.695 227.202C153.695 225.082 155.843 223.363 158.494 223.363H215.714C218.364 223.363 220.513 225.082 220.513 227.202C220.513 229.322 218.365 231.042 215.714 231.042Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M180.176 225.466C180.88 225.466 181.037 225.194 181.179 224.883H181.792V229.523H180.88V225.983H180.176V225.466Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M182.818 225.995C182.818 225.253 183.307 224.829 184.202 224.829C185.097 224.829 185.586 225.253 185.586 225.995V228.409C185.586 229.151 185.097 229.575 184.202 229.575C183.307 229.575 182.818 229.151 182.818 228.409V225.995ZM183.73 228.455C183.73 228.787 183.912 228.912 184.202 228.912C184.492 228.912 184.674 228.787 184.674 228.455V225.95C184.674 225.619 184.492 225.493 184.202 225.493C183.912 225.493 183.73 225.619 183.73 225.95V228.455Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M186.098 225.995C186.098 225.253 186.587 224.829 187.482 224.829C188.377 224.829 188.866 225.253 188.866 225.995V228.409C188.866 229.151 188.377 229.575 187.482 229.575C186.587 229.575 186.098 229.151 186.098 228.409V225.995ZM187.01 228.455C187.01 228.787 187.192 228.912 187.482 228.912C187.772 228.912 187.954 228.787 187.954 228.455V225.95C187.954 225.619 187.772 225.493 187.482 225.493C187.192 225.493 187.01 225.619 187.01 225.95V228.455Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M189.402 225.592C189.402 225.114 189.709 224.85 190.28 224.85C190.851 224.85 191.158 225.114 191.158 225.592V227.116C191.158 227.594 190.851 227.858 190.28 227.858C189.708 227.858 189.402 227.594 189.402 227.116V225.592ZM189.982 227.15C189.982 227.355 190.089 227.441 190.28 227.441C190.462 227.441 190.578 227.355 190.578 227.15V225.558C190.578 225.353 190.462 225.267 190.28 225.267C190.089 225.267 189.982 225.353 189.982 225.558V227.15ZM192.567 224.882H193.106L190.819 229.522H190.28L192.567 224.882ZM192.277 227.289C192.277 226.811 192.584 226.546 193.155 226.546C193.727 226.546 194.033 226.811 194.033 227.289V228.813C194.033 229.29 193.727 229.555 193.155 229.555C192.583 229.555 192.277 229.29 192.277 228.813V227.289ZM192.857 228.846C192.857 229.052 192.965 229.138 193.155 229.138C193.337 229.138 193.453 229.052 193.453 228.846V227.255C193.453 227.05 193.337 226.964 193.155 226.964C192.965 226.964 192.857 227.05 192.857 227.255V228.846Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M140.368 134.024C149.42 123.937 146.538 109.89 133.93 102.648C121.322 95.4068 103.763 97.713 94.7106 107.799C85.6585 117.886 88.5411 131.933 101.149 139.175C113.757 146.416 131.316 144.11 140.368 134.024Z",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M139.216 103.211C127.83 94.2657 109.575 93.6697 97.291 102.168",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M146.373 129.941C150.423 121.656 148.745 111.901 140.965 104.704",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M139.746 143.981L145.391 146.668L140.613 137.422C141.404 136.716 142.136 135.982 142.81 135.223",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2891 139.647C107.745 146.897 123.082 147.696 134.642 141.552L137.423 142.876",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7817 111.716C84.6387 120.034 86.2937 129.868 94.1207 137.109",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9185 106.992C91.2345 107.797 90.6165 108.628 90.0625 109.48",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M112.494 128.996L102.779 121.515C101.876 120.82 101.849 119.671 102.718 118.949C103.586 118.227 105.023 118.205 105.926 118.9",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M128.573 111.253C129.27 110.42 130.679 110.195 131.721 110.753C132.762 111.311 133.042 112.438 132.345 113.272L118.079 130.335C117.706 130.781 117.104 131.073 116.436 131.13C116.369 131.136 116.302 131.139 116.236 131.141C115.637 131.149 115.055 130.969 114.619 130.633",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M108.145 120.608L115.814 126.514L126.704 113.487",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M407.03 122.082C407.03 122.082 393.073 120.84 384.457 108.545C375.841 96.2496 329.865 100.29 329.865 100.29C329.865 100.29 330.13 104.596 337.251 105.705L332.284 107.622C332.284 107.622 333.738 112.549 346.777 112.115L343.24 115.165C343.24 115.165 348.717 118.746 362.46 117.172L359.869 119.838C359.869 119.838 366.294 123.416 377.186 120.905L376.016 123.376C376.016 123.376 384.284 123.854 389.151 122.155C389.151 122.155 398.569 126.798 407.03 122.082Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_146_427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 329,
    y: 99,
    width: 79,
    height: 26
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M407.03 122.082C407.03 122.082 393.073 120.84 384.457 108.545C375.841 96.2496 329.865 100.29 329.865 100.29C329.865 100.29 330.13 104.596 337.251 105.705L332.284 107.622C332.284 107.622 333.738 112.549 346.777 112.115L343.24 115.165C343.24 115.165 348.717 118.746 362.46 117.172L359.869 119.838C359.869 119.838 366.294 123.416 377.186 120.905L376.016 123.376C376.016 123.376 384.284 123.854 389.151 122.155C389.151 122.155 398.569 126.798 407.03 122.082Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_146_427)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M407.03 122.085C398.57 126.8 389.15 122.158 389.15 122.158C384.281 123.85 376.018 123.381 376.018 123.381L377.182 120.904C366.288 123.421 359.865 119.839 359.865 119.839L362.458 117.173C348.718 118.749 343.235 115.164 343.235 115.164L346.775 112.117C333.738 112.547 332.286 107.625 332.286 107.625L337.254 105.709C330.127 104.594 329.859 100.291 329.859 100.291C329.859 100.291 332.473 104.009 339.992 103.889C339.992 103.889 338.728 106.399 346.431 106.863C346.431 106.863 352.935 109.085 357.655 107.425C357.655 107.425 359.242 110.002 364.899 109.563L362.982 111.587C362.982 111.587 363.569 114.241 370.581 112.924L369.558 115.528C369.558 115.528 371.862 117.662 380.882 116.073C380.882 116.073 378.061 117.549 378.986 118.297C379.911 119.045 382.763 119.41 385.222 119.216C385.222 119.214 394.851 125.287 407.03 122.085Z",
    fill: "#586AFF"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M407.03 122.082C407.03 122.082 393.073 120.84 384.457 108.545C375.841 96.2496 329.865 100.29 329.865 100.29C329.865 100.29 330.13 104.596 337.251 105.705L332.284 107.622C332.284 107.622 333.738 112.549 346.777 112.115L343.24 115.165C343.24 115.165 348.717 118.746 362.46 117.172L359.869 119.838C359.869 119.838 366.294 123.416 377.186 120.905L376.016 123.376C376.016 123.376 384.284 123.854 389.151 122.155C389.151 122.155 398.569 126.798 407.03 122.082Z",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M347.401 102.628C342.77 103.564 339.975 103.261 336.533 104.665C336.533 104.665 339.571 107.945 347.433 107.502",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M347.401 102.628C342.77 103.564 339.975 103.261 336.533 104.665C336.533 104.665 339.571 107.945 347.433 107.502",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M350.921 108.768C348.315 109.136 345.105 110.225 345.105 110.225C345.105 110.225 346.239 114.488 358.754 112.444",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M363.624 113.874L359.961 115.76C359.961 115.76 366.378 118.07 373.363 116.524",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M376.959 116.629C376.959 116.629 373.376 118.646 373.497 118.93C373.617 119.214 380.666 121.327 387.05 118.549",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M376.959 116.629C376.959 116.629 373.376 118.646 373.497 118.93C373.617 119.214 380.666 121.327 387.05 118.549",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M355.024 103.83C352.83 104.59 346.339 105.384 345.91 106.144C345.91 106.144 348.035 110.9 358.934 108.217",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M355.024 103.83C352.83 104.59 346.339 105.384 345.91 106.144C345.91 106.144 348.035 110.9 358.934 108.217",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M362.292 109.374C359.413 110.325 357.682 111.502 357.682 111.502C357.682 111.502 361.901 116.196 372.151 112.145",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M362.292 109.374C359.413 110.325 357.682 111.502 357.682 111.502C357.682 111.502 361.901 116.196 372.151 112.145",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M373.453 112.14C370.338 113.284 369.562 115.532 369.562 115.532C369.562 115.532 374.624 118.152 383.315 115.425",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M373.453 112.14C370.338 113.284 369.562 115.532 369.562 115.532C369.562 115.532 374.624 118.152 383.315 115.425",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M364.004 105.452C364.004 105.452 357.82 106.511 357.654 107.423C357.654 107.423 362.616 110.839 370.561 109.122",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M364.004 105.452C364.004 105.452 357.82 106.511 357.654 107.423C357.654 107.423 362.616 110.839 370.561 109.122",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M371.495 108.684C370.036 109.206 369.055 110.316 369.055 110.316C369.055 110.316 371.445 113.152 377.6 111.609",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M371.495 108.684C370.036 109.206 369.055 110.316 369.055 110.316C369.055 110.316 371.445 113.152 377.6 111.609",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M413.991 104.891L409.147 106.225L406.834 102.347C406.589 101.936 406.018 101.746 405.476 101.896L389.018 106.431C388.476 106.58 388.116 107.026 388.162 107.492L388.593 111.888L361.104 119.464C359.792 119.825 359.019 120.993 359.377 122.073L370.478 155.548C370.836 156.628 372.19 157.21 373.502 156.848L426.39 142.274C427.702 141.912 428.475 140.744 428.117 139.664L417.016 106.189C416.657 105.112 415.303 104.529 413.991 104.891Z",
    fill: "#586AFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_146_427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 359,
    y: 101,
    width: 70,
    height: 56
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M413.991 104.891L409.147 106.225L406.834 102.347C406.589 101.936 406.018 101.746 405.476 101.896L389.018 106.431C388.476 106.58 388.116 107.026 388.162 107.492L388.593 111.888L361.104 119.464C359.792 119.825 359.019 120.993 359.377 122.073L370.478 155.548C370.836 156.628 372.19 157.21 373.502 156.848L426.39 142.274C427.702 141.912 428.475 140.744 428.117 139.664L417.016 106.189C416.657 105.112 415.303 104.529 413.991 104.891Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_146_427)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M413.991 104.891L409.147 106.225L406.834 102.347C406.589 101.936 406.018 101.746 405.476 101.896L389.018 106.431C388.476 106.58 388.116 107.026 388.162 107.492L388.593 111.888L361.104 119.464C359.792 119.825 359.019 120.993 359.377 122.073L370.478 155.548C370.836 156.628 372.19 157.21 373.502 156.848L426.39 142.274C427.702 141.912 428.475 140.744 428.117 139.664L417.016 106.189C416.657 105.112 415.303 104.529 413.991 104.891Z",
    fill: "black"
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M413.991 104.891L409.147 106.225L406.834 102.347C406.589 101.936 406.018 101.746 405.476 101.896L389.018 106.431C388.476 106.58 388.116 107.026 388.162 107.492L388.593 111.888L361.104 119.464C359.792 119.825 359.019 120.993 359.377 122.073L370.478 155.548C370.836 156.628 372.19 157.21 373.502 156.848L426.39 142.274C427.702 141.912 428.475 140.744 428.117 139.664L417.016 106.189C416.657 105.112 415.303 104.529 413.991 104.891Z",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M426.08 142.311L373.19 156.886C371.876 157.249 370.316 156.722 369.713 155.713L369.455 155.285L356.974 134.626L350.8 124.414C350.196 123.405 350.764 122.292 352.069 121.933L404.959 107.358C406.273 106.995 407.833 107.522 408.437 108.531L427.35 139.83C427.962 140.837 427.394 141.949 426.08 142.311Z",
    fill: "#586AFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_146_427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 350,
    y: 107,
    width: 78,
    height: 51
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M426.08 142.311L373.19 156.886C371.876 157.249 370.316 156.722 369.713 155.713L369.455 155.285L356.974 134.626L350.8 124.414C350.196 123.405 350.764 122.292 352.069 121.933L404.959 107.358C406.273 106.995 407.833 107.522 408.437 108.531L427.35 139.83C427.962 140.837 427.394 141.949 426.08 142.311Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_146_427)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M388.304 134.902C388.304 134.902 387.747 144.27 375.283 146.199C375.283 146.199 374.121 150.649 369.454 155.285L356.973 134.627C367.532 136.083 379.644 136.9 388.304 134.902Z",
    fill: "black"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M426.08 142.311L373.19 156.886C371.876 157.249 370.316 156.722 369.713 155.713L369.455 155.285L356.974 134.626L350.8 124.414C350.196 123.405 350.764 122.292 352.069 121.933L404.959 107.358C406.273 106.995 407.833 107.522 408.437 108.531L427.35 139.83C427.962 140.837 427.394 141.949 426.08 142.311Z",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M388.302 134.9C388.302 134.9 374.584 137.307 361.494 127.872C348.403 118.439 306.477 134.064 306.477 134.064C306.477 134.064 308.455 138.075 315.644 137.298L311.708 140.389C311.708 140.389 315.061 144.682 327.237 140.925L325.11 144.721C325.11 144.721 331.734 146.707 344.119 141.69L342.734 144.88C342.734 144.88 350.255 146.619 359.563 141.447L359.446 144.087C359.446 144.087 367.468 142.418 371.397 139.559C371.397 139.559 382.18 141.539 388.302 134.9Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_146_427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 306,
    y: 124,
    width: 83,
    height: 22
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M388.302 134.9C388.302 134.9 374.584 137.307 361.494 127.872C348.403 118.439 306.477 134.064 306.477 134.064C306.477 134.064 308.455 138.075 315.644 137.298L311.708 140.389C311.708 140.389 315.061 144.682 327.237 140.925L325.11 144.721C325.11 144.721 331.734 146.707 344.119 141.69L342.734 144.88C342.734 144.88 350.255 146.619 359.563 141.447L359.446 144.087C359.446 144.087 367.468 142.418 371.397 139.559C371.397 139.559 382.18 141.539 388.302 134.9Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_146_427)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M388.305 134.902C382.183 141.539 371.4 139.56 371.4 139.56C367.467 142.412 359.452 144.088 359.452 144.088L359.561 141.444C350.252 146.624 342.732 144.88 342.732 144.88L344.118 141.688C331.737 146.708 325.105 144.72 325.105 144.72L327.237 140.925C315.061 144.678 311.712 140.389 311.712 140.389L315.648 137.299C308.45 138.072 306.471 134.065 306.471 134.065C306.471 134.065 310.438 136.915 317.512 134.872C317.512 134.872 317.321 137.573 324.803 136.036C324.803 136.036 331.854 136.471 335.659 133.688C335.659 133.688 338.195 135.722 343.377 133.854L342.373 136.263C342.373 136.263 343.993 138.625 350.106 135.579L350.181 138.308C350.181 138.308 353.219 139.738 361.125 135.918C361.125 135.918 359.045 138.04 360.221 138.511C361.397 138.982 364.245 138.595 366.496 137.78C366.496 137.78 378.053 141.061 388.305 134.902Z",
    fill: "#586AFF"
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M388.302 134.9C388.302 134.9 374.584 137.307 361.494 127.872C348.403 118.439 306.477 134.064 306.477 134.064C306.477 134.064 308.455 138.075 315.644 137.298L311.708 140.389C311.708 140.389 315.061 144.682 327.237 140.925L325.11 144.721C325.11 144.721 331.734 146.707 344.119 141.69L342.734 144.88C342.734 144.88 350.255 146.619 359.563 141.447L359.446 144.087C359.446 144.087 367.468 142.418 371.397 139.559C371.397 139.559 382.18 141.539 388.302 134.9Z",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M324.022 131.777C320.011 133.853 317.242 134.283 314.545 136.496C314.545 136.496 318.738 138.823 326.006 136.385",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M324.022 131.777C320.011 133.853 317.242 134.283 314.545 136.496C314.545 136.496 318.738 138.823 326.006 136.385",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M329.819 136.689C327.498 137.706 324.895 139.562 324.895 139.562C324.895 139.562 327.679 143.309 338.712 138.161",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M343.899 138.266L341.186 140.992C341.186 140.992 348.19 141.532 354.186 138.275",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M357.633 137.453C357.633 137.453 355.048 140.282 355.276 140.52C355.504 140.757 363.027 140.949 367.96 136.681",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M357.633 137.453C357.633 137.453 355.048 140.282 355.276 140.52C355.504 140.757 363.027 140.949 367.96 136.681",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M331.725 130.959C329.952 132.241 324.122 134.659 324.02 135.49C324.02 135.49 327.94 139.449 337.187 134.111",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M331.725 130.959C329.952 132.241 324.122 134.659 324.02 135.49C324.02 135.49 327.94 139.449 337.187 134.111",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M340.831 134.345C338.486 135.985 337.318 137.543 337.318 137.543C337.318 137.543 343.197 140.906 351.28 134.439",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M340.831 134.345C338.486 135.985 337.318 137.543 337.318 137.543C337.318 137.543 343.197 140.906 351.28 134.439",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M352.513 134.101C350.022 135.983 350.188 138.312 350.188 138.312C350.188 138.312 356.034 139.495 363.171 134.681",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M352.513 134.101C350.022 135.983 350.188 138.312 350.188 138.312C350.188 138.312 356.034 139.495 363.171 134.681",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M340.882 130.191C340.882 130.191 335.449 132.782 335.658 133.687C335.658 133.687 341.728 135.65 348.564 131.984",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M340.882 130.191C340.882 130.191 335.449 132.782 335.658 133.687C335.658 133.687 341.728 135.65 348.564 131.984",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M349.271 131.329C348.099 132.199 347.615 133.502 347.615 133.502C347.615 133.502 351.015 135.575 356.226 132.533",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M349.271 131.329C348.099 132.199 347.615 133.502 347.615 133.502C347.615 133.502 351.015 135.575 356.226 132.533",
    stroke: "#193A5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M281.324 248.743C282.512 248.422 283.768 248.057 285.079 247.647",
    stroke: "#193A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M289.63 246.12C312.193 238.037 345.229 218.683 338.114 187.175C332.262 161.26 305.468 163.566 297.41 168.911C283.735 177.984 281.663 199.336 301.45 203.773C334.246 211.127 359.177 178.367 367.329 165.903",
    stroke: "#193A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7.9 4.94"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M368.459 164.142C369.593 162.332 370.185 161.259 370.185 161.259",
    stroke: "#193A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/Student.64f20d84469ba4c16d0fac90ca0937f8.svg";
export { ForwardRef as ReactComponent };